
import Injection = EECore.Injection;

@Injection.injectableClass("DocumentCentreQuickSearch")
export default class QuickSearch implements EECore.UI.IWebComponent {

  @Injection.injectableProperty("DocumentCentreQuickSearch", EECore.Registrations.TEMPLATE_FACTORY)
  private templateFactory: EECore.UI.TemplateFactory;

  constructor(templateFactory: EECore.UI.TemplateFactory) {
    this.templateFactory = templateFactory;
  }

  load(): Element {
    return this.renderTemplate();
  }

  private renderTemplate(): Element {
    return this.templateFactory.getTemplate("DocumentCentreQuickSearch", null);
  }
}